"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const registration = (sdk) => {
    const { sdkConfig: { url }, defaultVersion } = sdk;
    const httpClient = sdk.httpClient;
    return {
        confirm: async (token, payload) => {
            const endpoint = `${url}/${defaultVersion}/register/confirm/${token}`;
            const result = await httpClient.put(endpoint, { payload, auth: false });
            return result.data;
        },
        registerLibrary: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/register/library/app`;
            const result = await httpClient.post(endpoint, { payload, auth: false });
            return result.data;
        },
        registerPremium: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/register/premium/app`;
            const result = await httpClient.post(endpoint, { payload, auth: false });
            return result.data;
        },
        registerBasis: async (payload) => {
            const endpoint = `${url}/${defaultVersion}/register`;
            const result = await httpClient.post(endpoint, { payload, auth: false });
            return result.data;
        }
    };
};
exports.default = registration;
